import { Injectable } from '@angular/core'
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap'

@Injectable()
export class UkDateParserFormatter extends NgbDateParserFormatter {
    parse(value: string): NgbDateStruct | null {
        if (!value) return null

        const normalized = value.trim().replace(/\//g, '-')
        const datePart = normalized.split('T')[0]

        if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) {
            const [year, month, day] = datePart.split('-')
            return {
                day: +day,
                month: +month,
                year: +year,
            }
        }

        const [day, month, year] = datePart.split('-')

        return {
            day: +day,
            month: +month,
            year: +year,
        }
    }

    format(date: NgbDateStruct | null): string {
        if (!date) return ''
        return `${this.pad(date.day)}-${this.pad(date.month)}-${date.year}`
    }

    private pad(n: number): string {
        return n < 10 ? `0${n}` : `${n}`
    }
}
